import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

const listRoutines = () => {
  const url = `${AGENTCORE_ENGINE_API}/routine`;
  return backend.get(url);
};

const getRoutine = (routineRn) => {
  const url = `${AGENTCORE_ENGINE_API}/routine/${routineRn}`;
  return backend.get(url);
};

const updateRoutine = (routineRn, body) => {
  const url = `${AGENTCORE_ENGINE_API}/routine/${routineRn}`;
  return backend.put(url, body);
};

const setRoutineStatus = (routineRn, status) => {
  const url = `${AGENTCORE_ENGINE_API}/routine/${routineRn}/status`;
  return backend.put(url, {status});
};

const runRoutine = (routineRn) => {
  const url = `${AGENTCORE_ENGINE_API}/routine/${routineRn}/run`;
  return backend.post(url);
};

export default {list: listRoutines, get: getRoutine, update: updateRoutine, setStatus: setRoutineStatus, run: runRoutine};
